export default "__VITE_ASSET__Dwu8K3Wz__"